/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getTotem, setCidade } from '../../api/apiFactory';
import {
  fetchGraficos, fetchLimparCookie, fetchNomeCidade, fetchAnos,
} from '../../api/endpoints';
import { definirCidade, fetchConfiguracoesCidade, selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao } from '../../app/slices/loginSlice';
import { resetarModais, selectModal } from '../../app/slices/modalSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import Carregar from '../../components/Carregar/Carregar';
import FormControl from '../../components/FormControl/FormControl';
import { LinhaForm } from '../../components/FormControl/FormControlEstilo';
import Grafico from '../../components/Grafico/Grafico';
import {
  BordaTabela, CelulaTitulo, CelulaValor, LinhaTabela,
} from '../../components/Grafico/GraficoEstilo';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import {
  AppBody, AppFragment, Container, Divisor, Interno, Titulo,
} from '../../styles/base';
import { ouvidoriaStatusColorScale, sicStatusColorScale } from '../../styles/constants/colors';

const menuGraficos = [
  {
    Id: 'pedidoAssunto',
    Campo: 'Ouvidoria - Assuntos',
  },
  {
    Id: 'ouvidoriaPrazos',
    Campo: 'Ouvidoria - Prazos',
  },
  {
    Id: 'ouvidoriaPrimeiraResposta',
    Campo: 'Ouvidoria - Primeira resposta',
    cores: ouvidoriaStatusColorScale,
  },
  {
    Id: 'pedidoSecretaria',
    Campo: 'Ouvidoria - Secretarias',
  },
  {
    Id: 'ouvidoriaSigiloso',
    Campo: 'Ouvidoria - Dados sigilosos',
    cores: ouvidoriaStatusColorScale,
  },
  {
    Id: 'ouvidoriaStatus',
    Campo: 'Ouvidoria - Status',
    cores: ouvidoriaStatusColorScale,
  },
  {
    Id: 'ouvidoriaTempoResposta',
    Campo: 'Ouvidoria - Tempo de resposta',
  },
  {
    Id: 'sicPrazos',
    Campo: 'Sic - Prazos',
  },
  {
    Id: 'sicSigiloso',
    Campo: 'Sic - Dados sigilosos',
    cores: sicStatusColorScale,
  },
  {
    Id: 'sicStatus',
    Campo: 'Sic - Status',
    cores: sicStatusColorScale,
  },
];

const menuGraficosSemSic = [
  {
    Id: 'pedidoAssunto',
    Campo: 'Ouvidoria - Assuntos',
  },
  {
    Id: 'ouvidoriaPrazos',
    Campo: 'Ouvidoria - Prazos',
  },
  {
    Id: 'ouvidoriaPrimeiraResposta',
    Campo: 'Ouvidoria - Primeira resposta',
    cores: ouvidoriaStatusColorScale,
  },
  {
    Id: 'pedidoSecretaria',
    Campo: 'Ouvidoria - Secretarias',
  },
  {
    Id: 'ouvidoriaSigiloso',
    Campo: 'Ouvidoria - Dados sigilosos',
    cores: ouvidoriaStatusColorScale,
  },
  {
    Id: 'ouvidoriaStatus',
    Campo: 'Ouvidoria - Status',
    cores: ouvidoriaStatusColorScale,
  },
  {
    Id: 'ouvidoriaTempoResposta',
    Campo: 'Ouvidoria - Tempo de resposta',
  },
];

const menuDatasMeses = [
  {
    Id: '0',
    Campo: 'Todos',
  },
  {
    Id: '1',
    Campo: 'Janeiro',
  },
  {
    Id: '2',
    Campo: 'Fevereiro',
  },
  {
    Id: '3',
    Campo: 'Março',
  },
  {
    Id: '4',
    Campo: 'Abril',
  },
  {
    Id: '5',
    Campo: 'Maio',
  },
  {
    Id: '6',
    Campo: 'Junho',
  },
  {
    Id: '7',
    Campo: 'Julho',
  },
  {
    Id: '8',
    Campo: 'Agosto',
  },
  {
    Id: '9',
    Campo: 'Setembro',
  },
  {
    Id: '10',
    Campo: 'Outubro',
  },
  {
    Id: '11',
    Campo: 'Novembro',
  },
  {
    Id: '12',
    Campo: 'Dezembro',
  },
];

const IniciarGrafico = () => {
  const [tipo, setTipo] = useState('ouvidoriaStatus');
  const [dados, setDados] = useState(null);
  const [listaPedidos, setListaPedidos] = useState(null);
  const [ano, setAno] = useState((new Date()).getFullYear().toString());
  const [mes, setMes] = useState(0);
  const [listaAnos, setListaAnos] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();

  const dadosCidade = useSelector(selectCidade);
  const dadosModal = useSelector(selectModal);

  window.onload = () => {
    dispatch(resetarModais());
  };

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  const carregarGrafico = async () => {
    setDados(null);
    const endpoint = fetchGraficos[tipo];
    if (!(endpoint instanceof Function)) {
      return null;
    }

    if (tipo === 'pedidoAssunto' || tipo === 'pedidoSecretaria') {
      setDados('Vazio');
      setListaPedidos(null);

      const grafico = await endpoint({ mes, ano });
      setListaPedidos(grafico);
      return null;
    }

    const grafico = await endpoint({ mes, ano });
    setDados(grafico);
    return null;
  };

  useEffect(() => {
    if (getTotem() === 'true') {
      // setTimeout(() => {
      //   document.querySelector('body').click();
      //   document.querySelector('body').focus();
      //   document.querySelector('body').click();
      // }, 2000);

      history.push('/totem');
    }

    if (cookieId) {
      const escolherCidadeCookie = async (Id, Campo) => {
        setCidade({ Id, Campo });
        dispatch(definirCidade({
          idCidade: Id,
          nomeCidade: Campo,
        }));
        await fetchLimparCookie();
        await dispatch(fetchConfiguracoesCidade());
      };

      dispatch(desfazerConexao());
      fetchNomeCidade(cookieId).then((nomeCidade) => escolherCidadeCookie(cookieId, nomeCidade));
    }

    fetchAnos().then((dadosAnos) => setListaAnos(dadosAnos.reverse()));
    carregarGrafico();
  }, [tipo, mes, ano, dadosCidade, cookieId]);

  if (!dados || !listaAnos) {
    return (
      <Carregar />
    );
  }

  const opcaoGrafico = menuGraficos.find(({ Id }) => Id === tipo);

  if (tipo === 'pedidoAssunto' || tipo === 'pedidoSecretaria') {
    if (!listaPedidos) {
      return (
        <Carregar />
      );
    }

    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        <AppHeader />
        <AppBody desfoque={dadosModal.desfoque} className="controle-fundo">
          <Container>
            <Titulo>Gráficos</Titulo>

            <Interno>
              <LinhaForm>
                <FormControl
                  type="select"
                  noBlank
                  label="Opção:"
                  value={tipo}
                  options={dadosCidade.configuracoes.OcultarAppSic === 'S' ? menuGraficos : menuGraficosSemSic}
                  onChange={({ target }) => {
                    setTipo(target.value);
                    setAno(ano);
                  }}
                />

                <FormControl
                  type="select"
                  noBlank
                  label="Mês:"
                  value={mes}
                  options={menuDatasMeses}
                  onChange={({ target }) => setMes(target.value)}
                />

                <FormControl
                  type="selectAno"
                  noBlank
                  label="Ano:"
                  value={ano}
                  options={listaAnos}
                  onChange={({ target }) => setAno(target.value)}
                />
              </LinhaForm>

              <Divisor size="pequeno" />

              {tipo === 'pedidoAssunto' && (
                <>
                  <BordaTabela>
                    <LinhaTabela style={{ justifyContent: 'space-between' }}>
                      <div style={{ width: 150, display: 'flex', fontSize: 14 }}>
                        <b>Assuntos</b>
                      </div>
                      <div style={{
                        width: 150, display: 'flex', justifyContent: 'center', fontSize: 14,
                      }}
                      >
                        <b>Realizados</b>
                      </div>
                      <div style={{
                        width: 150, display: 'flex', justifyContent: 'center', fontSize: 14,
                      }}
                      >
                        <b>Não realizados</b>
                      </div>
                      <div style={{
                        width: 150, display: 'flex', justifyContent: 'center', fontSize: 14,
                      }}
                      >
                        <b>Total</b>
                      </div>
                    </LinhaTabela>
                    {listaPedidos && listaPedidos.map(({
                      Campo, Deferidos, Indeferidos, Total,
                    }) => (
                      <LinhaTabela>
                        <CelulaTitulo style={{ width: 150, display: 'flex' }}>
                          <span>{Campo}</span>
                        </CelulaTitulo>
                        <CelulaValor style={{ width: 150, display: 'flex', justifyContent: 'center' }}>
                          <span>{Deferidos || Deferidos === 0 ? Deferidos : null}</span>
                        </CelulaValor>
                        <CelulaValor style={{ width: 150, display: 'flex', justifyContent: 'center' }}>
                          <span>{Indeferidos || Indeferidos === 0 ? Indeferidos : null}</span>
                        </CelulaValor>
                        <CelulaValor style={{ width: 150, display: 'flex', justifyContent: 'center' }}>
                          <span>{Total || Total === 0 ? Total : null}</span>
                        </CelulaValor>
                      </LinhaTabela>
                    ))}
                  </BordaTabela>
                </>
              )}

              {tipo === 'pedidoSecretaria' && (
                <>
                  <BordaTabela>
                    <LinhaTabela style={{ justifyContent: 'space-between' }}>
                      <div style={{ width: 150, display: 'flex', fontSize: 14 }}>
                        <b>Secretarias</b>
                      </div>
                      <div style={{
                        width: 150, display: 'flex', justifyContent: 'center', fontSize: 14,
                      }}
                      >
                        <b>Realizados</b>
                      </div>
                      <div style={{
                        width: 150, display: 'flex', justifyContent: 'center', fontSize: 14,
                      }}
                      >
                        <b>Não realizados</b>
                      </div>
                      <div style={{
                        width: 150, display: 'flex', justifyContent: 'center', fontSize: 14,
                      }}
                      >
                        <b>Total</b>
                      </div>
                    </LinhaTabela>
                    {listaPedidos && listaPedidos.map(({
                      Campo, Deferidos, Indeferidos, Total,
                    }) => (
                      <LinhaTabela>
                        <CelulaTitulo style={{ width: 150, display: 'flex' }}>
                          <span>{Campo}</span>
                        </CelulaTitulo>
                        <CelulaValor style={{ width: 150, display: 'flex', justifyContent: 'center' }}>
                          <span>{Deferidos || Deferidos === 0 ? Deferidos : null}</span>
                        </CelulaValor>
                        <CelulaValor style={{ width: 150, display: 'flex', justifyContent: 'center' }}>
                          <span>{Indeferidos || Indeferidos === 0 ? Indeferidos : null}</span>
                        </CelulaValor>
                        <CelulaValor style={{ width: 150, display: 'flex', justifyContent: 'center' }}>
                          <span>{Total || Total === 0 ? Total : null}</span>
                        </CelulaValor>
                      </LinhaTabela>
                    ))}
                  </BordaTabela>
                </>
              )}

            </Interno>
          </Container>
        </AppBody>
      </AppFragment>
    );
  }

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      <AppHeader />
      <AppBody
        desfoque={dadosModal.desfoque}
        className="controle-fundo"
      >
        <Container>
          <Titulo>Gráficos</Titulo>

          <Interno>
            <LinhaForm>
              <FormControl
                type="select"
                noBlank
                label="Opção:"
                value={tipo}
                options={dadosCidade.configuracoes.OcultarAppSic === 'S' ? menuGraficos : menuGraficosSemSic}
                onChange={({ target }) => {
                  setTipo(target.value);
                  setAno(ano);
                }}
              />

              <FormControl
                type="select"
                noBlank
                label="Mês:"
                value={mes}
                options={menuDatasMeses}
                onChange={({ target }) => setMes(target.value)}
              />

              <FormControl
                type="selectAno"
                noBlank
                label="Ano:"
                value={ano}
                options={listaAnos}
                onChange={({ target }) => setAno(target.value)}
              />
            </LinhaForm>

            <Divisor size="pequeno" />

            <Grafico
              data={dados}
              tipo={opcaoGrafico}
            />
          </Interno>
        </Container>
      </AppBody>
    </AppFragment>
  );
};

export default IniciarGrafico;
